import {Action} from "@ngrx/store";
import {HostingDomainData} from "../../websites/website/hosting/domains/hostingDomainData";

export const LOAD_EXPANDED_DATA: string = '[domainsExpandedData] Load Expanded Data';
export const EXPANDED_DATA_SUCCESS: string = '[domainsExpandedData] Expanded Data Success';
export const EXPANDED_DATA_FAIL: string = '[domainsExpandedData] Expanded Data Fail';

export class LoadExpandedDomainsData implements Action {

  readonly type: string = LOAD_EXPANDED_DATA;

  constructor(public payload: number, public domainNameIds: any, public expanded: boolean) {
  }
}

export class ExpandedDomainsDataSuccess implements Action {

  readonly type: string = EXPANDED_DATA_SUCCESS;

  constructor(public payload: {
    websiteId: number,
    entities:{[websiteId: number]: HostingDomainData },
    expanded: boolean
  }) {
  }

}

export class ExpandedDomainsDataFail implements Action {

  readonly type: string = EXPANDED_DATA_FAIL;

  constructor(public payload: number) {}

}

export type ExpandedDomainsDataAction = LoadExpandedDomainsData | ExpandedDomainsDataSuccess | ExpandedDomainsDataFail;
